import { render } from "./card-info.vue?vue&type=template&id=9581ef00"
import script from "./card-info.vue?vue&type=script&lang=ts"
export * from "./card-info.vue?vue&type=script&lang=ts"

import "./card-info.vue?vue&type=style&index=0&id=9581ef00&lang=css"
script.render = render

export default script